'use client';

import axios from 'axios';
import { useFormik } from 'formik';
import { LoaderIcon } from 'lucide-react';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import * as yup from 'yup';


import { Button } from '@/shared/ui/atoms/button';
import { Input } from '@/shared/ui/atoms/input/ui';
import { Layout } from '@/widgets/layout/ui';

const ForgotPasswordPage: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const router = useRouter();

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: yup.object({
      email: yup.string().email('Invalid email').required('Required'),
    }),
    onSubmit: async (values) => {
      try {
        setIsLoading(true);
        await axios.post('/api/users/forgot-password', { email: values.email });

        router.push('/auth/sign-in');
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    },
  });

  return (
    <Layout>
      <form className='flex flex-col gap-4 max-w-md w-full mx-auto my-40 bg-gray-900 backdrop-blur-sm p-4 rounded-lg' onSubmit={formik.handleSubmit}>
        <h2 className='text-xl font-bold text-center'>Создать новый пароль</h2>
        <div className='text-sm text-gray-400 text-center'>
          Введите ваш email, чтобы получить ссылку для создания нового пароля.
        </div>
        <Input
          id='email'
          type='email'
          placeholder='Email'
          value={formik.values.email}
          error={formik.touched.email ? formik.errors.email : ''}
          onChange={formik.handleChange}
        />
        <Button type='submit' className='w-full' disabled={isLoading}>{isLoading ? <LoaderIcon className='animate-spin' /> : 'Отправить'}</Button>
      </form>
    </Layout>
  );
};

export default ForgotPasswordPage;
